import React from 'react'
import Sidebar from '../components/Sidebar'

const Product = () => {
    return (
        <>
        
            <div>
                Products
            </div>
        </>
    )
}

export default Product
